import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class RecurringServiceSelectComponent implements IController {

  selectedId: any;
  options: any;
  optionIds: any;
  skills: any;
  scheduleFrequency: string;
  byWeekDay: string[];
  noResourceAllocation?: boolean;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;

  private recurringServicesRef: any;
  public selectedRecurringService: any;
  public selectedText: any;
  public typeBySkillsMap: any;

  /* @ngInject */
  constructor(private $mdPanel, private $recurringServices, private $filter, private agentConstants) {
    this.recurringServicesRef = this.$recurringServices();
    this.typeBySkillsMap =  agentConstants.typeBySkills
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if (
      (changes.selectedId && !changes.selectedId.isFirstChange())
    ) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const serviceTypesRef = this.skills ? this.skills.map((s) => {
      return this.typeBySkillsMap[s];
    }) : undefined;
    const scheduleFrequencyRef = this.scheduleFrequency;
    const byWeekDayRef = this.byWeekDay;
    const noResourceAllocationRef = this.noResourceAllocation;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'recurring-service';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.queryMapRef = {
          serviceTypes: serviceTypesRef,
          scheduleFrequency: scheduleFrequencyRef,
          byWeekDay: byWeekDayRef,
          noResourceAllocation: noResourceAllocationRef
        };
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({recurringService: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const recurringService = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({recurringService: recurringService, id: selectedId});
            panel.destroy();
          } else {
            this.recurringServicesRef.$asyncValues([selectedId])
              .then((recurringServices) => {
                this.onChange({recurringService: recurringServices[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({recurringService: undefined, id: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedRecurringService = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.recurringServicesRef.$asyncValues([this.selectedId])
          .then((recurringServices) => {
            this.selectedRecurringService = _.orderBy(recurringServices, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedRecurringService = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    const serviceType = this.$filter('translate')( this.selectedRecurringService?.template?.serviceType || '');
    this.selectedText =`${_.get(this.selectedRecurringService, 'id', '')} ${serviceType} ${_.get(this.selectedRecurringService, 'accountReference.name', '')}`;
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('recurringServiceSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      options: '<?',
      optionIds: '<?',
      skills: '<?',
      scheduleFrequency: '<?',
      byWeekDay: '<?',
      noResourceAllocation: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./recurring-service-select.html').default,
    controller: RecurringServiceSelectComponent
  });
